import React from "react";
import { Button } from "rsuite";
import { Checkbox } from "rsuite";
import AttributeScatter from "./attributeScatter";

const RelevantAttributes = (props: any) => {
	return (
		<>
			<div className="sticky top-0 bg-[#ffff] z-[99] ">
				<div className="w-full pl-4 ">
					<h1 className="text-[2.5vh] font-bold text-black h-[6vh]">
						Input
					</h1>
					<p className="text-[2vh] text-black">
						Relevant Attributes for {props.selectedL4Filter}
					</p>
				</div>

				<div className="flex justify-start flex-wrap bg-[#ffff] ">
					{props?.attributeList?.map((item: any, k: any) => {
						return (
							<div className="w-[6.5vw]">
								<Checkbox
									defaultChecked
									color="green"
									checked={item.selected}
									onChange={(value, checked) => {
										props.handleButtonClick(item.Attribute);
									}}
									className="custom-checkbox w-full text-black px-[1vh] text-[1.5vh]"
								>
									{item.Attribute === "China"
										? "Country of Origin: China"
										: item.Attribute ===
										  "SnapIn_Cable_Connector"
										? "Type: SnapIn Cable Connector"
										: item.Attribute ===
										  "Duplex_Cable_Connector"
										? "Type: Duplex Cable Connector"
										: item.Attribute ===
										  "45_Degree_Configuration"
										? "Configuration: 45 degree"
										: item.Attribute.replaceAll("_", " ")}
								</Checkbox>
							</div>
						);
					})}
				</div>
			</div>

			<div className="flex flex-col h-fit">
				<span className="w-full text-center text-[2vh] font-medium mb-[3vh]">
					Attributional Relationship with Cost
				</span>
				<div className="flex h-full  w-full flex-wrap gap-[2vh] justify-evenly">
					{props?.attributeList?.map((item: any, key: any) => {
						return item.selected ? (
							<AttributeScatter attributeList={item} />
						) : (
							""
						);
					})}
				</div>
			</div>
		</>
	);
};
export default RelevantAttributes;
